export enum HomeActionTypes {
    UPDATE_ACTIVE_SUBAPPS = "[App Action][Home] UPDATE ACTIVE SUBAPPS",
    SELECT_SUBAPP = "[App Action][Home] SELECT SUBAPP",

    GET_USER_INFO = "[App Action][Home] GET USER INFO",
    GET_USER_INFO_SUCCESS = "[App Action][Home] GET USER INFO SUCCESS",
    GET_USER_INFO_FAIL = "[App Action][Home] GET USER INFO FAIL",

    LOGOUT = "[App Action][Home] LOGOUT",

    EDIT_USER_PASSWORD = "[App Action][Auth] EDIT USER PASSWORD"
}
